import { createSelector } from 'reselect';

import getElectDecoratedLocationsSelector from './getElectDecoratedLocationsSelector';

export default createSelector([getElectDecoratedLocationsSelector], (locations) => {
  return locations.reduce((total, location) => {
    const emissions = location.aggregated_tonnage || 0;
    return total + emissions;
  }, 0);
});
